
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import QModal from '../../Modal/Modal.vue';
import EyeIcon from '../../../Icons/Eye.vue';
/**
- Card for image preview
**/
export default Vue.extend<any, any, any, any>({
  name: 'ImagePreviewCard',
  components: {
    EuCard,
    QModal,
    EyeIcon
  },
  data() {
    return {
      isModalActive: false,
      fileSource: '',
      fileName: ''
    };
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'interactive'
    },
    /**
     * Value of Image Preview Card <br />
     * Can be in string form or object form <br />
     * Bind in `v-model`.
     */
    value: {
      type: [String, Object],
      default: null
    },
    /**
     * Text placed next to the image
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Custom Eye Icon
     */
    showPreviewIcon: {
      type: [Object, Function],
      default: () => EyeIcon
    },
    /**
     * Custom eye icon color fill
     */
    showPreviewIconFill: {
      type: String,
      default: 'var(--color-orange-light)'
    },
    /**
     * Show modal close button
     */
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (typeof this.value === 'string') {
      this.fileSource = this.value;
      this.fileName = this.placeholder;
    } else if (this.value && this.value.data) {
      this.fileSource = this.value.fileType.split('/')[0] === 'image' ? this.value.data : '';
      this.fileName = this.placeholder ? this.placeholder : this.value.fileName;
    }
  },
  methods: {
    toggleModal() {
      this.isModalActive = !this.isModalActive;
    },
    handleClick(e: any) {
      this.toggleModal();
      /**
       * Method to click card
       *  @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleBrokenImage(event: Event) {
      /**
       * Handle when image is broken
       * @event broken-state
       * @type {function}
       */
      this.$emit('broken-state', event);
    }
  }
});
